import React from 'react';
import Facet from './Facet';
import PropTypes from 'prop-types';
import sortBy from 'lodash/sortBy'

import { AttributesParamShape } from '../../Infrastructure/propShapes.js';

const Facets = ({
    attributes,
    onAttributeChange,
    onToggleFacetExpanded,
    updateOnToggle,
    onToggleShowMoreFacet
}) => {
            
    return (
        <div className="facets">
            {
                sortBy(attributes, a => a.sortOrder)
                    .map((attribute, i) => {
                    return (
                        <div className="mb-1 mb-lg-3" key={i}>
                            <Facet
                                name={attribute.name}
                                displayName={attribute.displayName}
                                values={attribute.values}
                                onAttributeChange={onAttributeChange}
                                expanded={attribute.expanded}
                                onToggleFacetExpanded={onToggleFacetExpanded}
                                updateOnToggle={updateOnToggle}
                                showMore={attribute.showMore}
                                onToggleShowMore={onToggleShowMoreFacet}
                            />
                        </div>
                    );
                })
            }
        </div>
    );
};

Facets.propTypes = {...AttributesParamShape};

export default Facets;